import HostnamePage from './hostname';

export default {
    title: 'Containers/Node Configuration/Node Name'
}

export const nodeName = () => <HostnamePage />;
